// Copyright (c) 2017 Deere & Company

import SearchByDropDown from '@deere/cps-it.warranty-model-factory/lib/search-by-dropdown';

export const getDefaultState = () =>
    new SearchByDropDown({
        searchBy: [
            {
                key: 'PRODUCTS',
                value: 'PRODUCTS'
            },
            {
                key: 'PIPS',
                value: 'PIPS'
            },
            {
                key: 'PIP_PROGRAMS',
                value: 'PIP_PROGRAMS'
            },
            {
                key: 'PART_REQUESTS',
                value: 'PART_REQUESTS'
            },
            {
                key: 'CLAIMS',
                value: 'CLAIMS'
            }
        ],
        selectedOption: {
            key: 'PRODUCTS',
            value: 'PRODUCTS'
        }
    });

export default SearchByDropDown;



// WEBPACK FOOTER //
// ./src/tabm/wip/state/search-by-dropdown.js